import { useRouteMatch } from 'react-router-dom';

type SelectedPartyParams = {
  partyId?: string;
};

export const useSelectedPartyId = () => {
  const { path } = useRouteMatch();
  const selectedMatch = useRouteMatch<SelectedPartyParams>({
    path: `${path}/:partyId`,
    exact: true,
  });

  return selectedMatch?.params.partyId;
};

export default useSelectedPartyId;
